// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpdateConfirmationModal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
  z-index: 3;
}
.UpdateConfirmationModal .Modal {
  padding: 2.5rem 5rem;
  min-width: 40rem;
  max-width: 80%;
  background: var(--Foreground);
  border-radius: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  overflow: auto;
}
.UpdateConfirmationModal .Modal h1 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: var(--AccentColor);
}
.UpdateConfirmationModal .Modal span {
  font-size: 0.875rem;
  text-align: center;
  text-wrap: balance;
  color: var(--TextColor);
}
.UpdateConfirmationModal .Modal .CandidatesList {
  min-width: auto;
  max-width: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr));
  gap: 1.25rem;
  max-height: 22rem;
  overflow: auto;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate {
  padding: 0.75rem;
  padding-top: 1.25rem;
  border-radius: 0.5rem;
  border: 0.0625rem solid var(--Stroke);
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: flex-start;
  position: relative;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values {
  flex: 1 1;
  max-width: 50%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 0.5rem;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue .Label {
  font-size: 0.625rem;
  font-weight: 500;
  color: var(--AccentColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue .Value {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue .Status {
  padding: 0.25rem 0.625rem;
  border-radius: 1.25rem;
  text-transform: capitalize;
  font-size: 0.625rem;
  border: 0.0625rem solid var(--Stroke);
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue .invitation {
  background: var(--Invitation);
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue .accepted {
  background: var(--Accepted);
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue .inprogress {
  background: var(--Inprogress);
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue .pending {
  background: var(--Pending);
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue .completed {
  background: var(--Completed);
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue .cancelled {
  background: var(--Cancelled);
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .Values .LabelValue .re-initiated {
  background: var(--Reinitiated);
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .ChecksCont {
  flex: 1 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-left: 1rem;
  border-left: 0.0625rem solid var(--Stroke);
  overflow: hidden;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .ChecksCont h3 {
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--AccentColor);
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .ChecksCont .Check {
  width: calc(100% - 1rem);
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .ChecksCont .Check svg {
  min-width: 0.75rem;
  min-height: 0.75rem;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .ChecksCont .Check svg path {
  fill: var(--AccentColor);
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .ChecksCont .Check span {
  width: calc(100% - 1.25rem);
  font-size: 0.75rem;
  color: var(--TextColor);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate .DIMyself {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 0.5rem;
  background: var(--AccentColor);
  padding: 0.25rem 0.5rem;
  border-radius: 0 0.5rem 0 0.5rem;
  color: #ffffff;
}
.UpdateConfirmationModal .Modal .CandidatesList .Candidate:hover:not(.Selected, .NotAllowed) {
  background: var(--Hover);
  cursor: pointer;
}
.UpdateConfirmationModal .Modal .CandidatesList .Selected {
  background: var(--Invitation);
  border: 0.0625rem solid var(--AccentColor);
  cursor: pointer;
}
.UpdateConfirmationModal .Modal .CandidatesList .NotAllowed {
  background: #ffecec;
  cursor: not-allowed;
}
.UpdateConfirmationModal .Modal .CandidatesList .NotAllowed:hover {
  opacity: 0.7;
}
.UpdateConfirmationModal .Modal .ButtonContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3.75rem;
  margin-top: 1.25rem;
}
.UpdateConfirmationModal .Modal .ButtonContainer button {
  height: 2rem;
  width: 8.75rem;
  border: none;
  border-radius: 0.5rem;
  color: #FFFFFF;
  font-size: 0.875rem;
  background: var(--AccentColor);
  font-weight: 500;
  cursor: pointer;
}
.UpdateConfirmationModal .Modal .ButtonContainer button:disabled {
  opacity: 0.2;
  scale: 1;
  cursor: not-allowed;
}
.UpdateConfirmationModal .Modal .ButtonContainer .Skip {
  background: var(--Background);
  color: var(--AccentColor);
  transition: all 0.3s ease;
}
.UpdateConfirmationModal .Modal .ButtonContainer .Skip:hover {
  background: var(--Stroke);
  color: var(--TextColor);
  transition: all 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/Components/BeginVerification/UpdateConfirmationModal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,0BAAA;EACA,UAAA;AACJ;AAAI;EACE,oBAAA;EAEA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AACN;AAAM;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;AAER;AAAM;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAER;AAAM;EACE,eAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,4DAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAER;AADQ;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,kBAAA;AAGV;AAFU;EACE,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAIZ;AAHY;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AAKd;AAJc;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAMhB;AAJc;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAMhB;AAJc;EACE,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,mBAAA;EACA,qCAAA;AAMhB;AAJc;EACE,6BAAA;AAMhB;AAJc;EACE,2BAAA;AAMhB;AAJc;EACE,6BAAA;AAMhB;AAJc;EACE,0BAAA;AAMhB;AAJc;EACE,4BAAA;AAMhB;AAJc;EACE,4BAAA;AAMhB;AAJc;EACE,8BAAA;AAMhB;AAFU;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;AAIZ;AAHY;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;AAKd;AAHY;EACE,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AAKd;AAJc;EACE,kBAAA;EACA,mBAAA;AAMhB;AALgB;EACE,wBAAA;AAOlB;AAJc;EACE,2BAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAMhB;AAFU;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,iBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,cAAA;AAIZ;AADQ;EACE,wBAAA;EACA,eAAA;AAGV;AADQ;EACE,6BAAA;EACA,0CAAA;EACA,eAAA;AAGV;AADQ;EACE,mBAAA;EACA,mBAAA;AAGV;AADQ;EACE,YAAA;AAGV;AAAM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAER;AADQ;EACE,YAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;AAGV;AADQ;EACE,YAAA;EACA,QAAA;EACA,mBAAA;AAGV;AADQ;EACE,6BAAA;EACA,yBAAA;EACA,yBAAA;AAGV;AADQ;EACE,yBAAA;EACA,uBAAA;EACA,yBAAA;AAGV","sourcesContent":[".UpdateConfirmationModal{\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100vw;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #000000b3;\n    backdrop-filter: blur(3px);\n    z-index: 3;\n    .Modal{\n      padding: 2.5rem 5rem;\n      // width: 50%;\n      min-width: 40rem;\n      max-width: 80%;\n      background: var(--Foreground);\n      border-radius: 1.25rem;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 1.25rem;\n      overflow: auto;\n      h1{\n        font-size: 1.5rem;\n        font-weight: 700;\n        margin: 0;\n        color: var(--AccentColor);\n      }\n      span{\n        font-size: 0.875rem;\n        text-align: center;\n        text-wrap: balance;\n        color: var(--TextColor);\n      }\n      .CandidatesList{\n        min-width: auto;\n        max-width: 100%;\n        width: 100%;\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr));\n        gap: 1.25rem;\n        max-height: 22rem;\n        overflow: auto;\n        .Candidate{\n          padding: 0.75rem;\n          padding-top:  1.25rem;\n          border-radius: 0.5rem;\n          border: 0.0625rem solid var(--Stroke);\n          display: flex;\n          flex-direction: row;\n          gap: 1rem;\n          align-items: flex-start;\n          position: relative;\n          .Values{\n            flex: 1;\n            max-width: 50%;\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n            .LabelValue{\n              width: 100%;\n              display: flex;\n              flex-direction: row;\n              align-items: baseline;\n              gap: 0.5rem;\n              .Label{\n                font-size: 0.625rem;\n                font-weight: 500;\n                color: var(--AccentColor);\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                text-align: left;\n              }\n              .Value{\n                font-size: 0.75rem;\n                font-weight: 400;\n                color: var(--TextColor);\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n              }\n              .Status{\n                padding: 0.25rem 0.625rem;\n                border-radius: 1.25rem;\n                text-transform: capitalize;\n                font-size: 0.625rem;\n                border: 0.0625rem solid var(--Stroke);\n              }\n              .invitation{\n                background: var(--Invitation);\n              }\n              .accepted{\n                background: var(--Accepted);\n              }\n              .inprogress{\n                background: var(--Inprogress);\n              }\n              .pending{\n                background: var(--Pending);\n              }\n              .completed{\n                background: var(--Completed);\n              }\n              .cancelled{\n                background: var(--Cancelled);\n              }\n              .re-initiated{\n                background: var(--Reinitiated);\n              }\n            }\n          }\n          .ChecksCont{\n            flex: 1;\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n            padding-left: 1rem;\n            border-left: 0.0625rem solid var(--Stroke);\n            overflow: hidden;\n            h3{\n              font-size: 0.75rem;\n              font-weight: 600;\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n              color: var(--AccentColor);\n            }\n            .Check{\n              width: calc(100% - 1rem);\n              display: flex;\n              flex-direction: row;\n              gap: 0.5rem;\n              align-items: center;\n              svg{\n                min-width: 0.75rem;\n                min-height: 0.75rem;\n                path{\n                  fill: var(--AccentColor);\n                }\n              }\n              span{\n                width: calc(100% - 1.25rem);\n                font-size: 0.75rem;\n                color: var(--TextColor);\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                text-align: left;\n              }\n            }\n          }\n          .DIMyself{\n            position: absolute;\n            top: 0;\n            right: 0;\n            font-size: 0.5rem;\n            background: var(--AccentColor);\n            padding: 0.25rem 0.5rem;\n            border-radius: 0 0.5rem 0 0.5rem;\n            color: #ffffff;\n          }\n        }\n        .Candidate:hover:not(.Selected, .NotAllowed){\n          background: var(--Hover);\n          cursor: pointer;\n        }\n        .Selected{\n          background: var(--Invitation);\n          border: 0.0625rem solid var(--AccentColor);\n          cursor: pointer;\n        }\n        .NotAllowed{\n          background: #ffecec;\n          cursor: not-allowed;\n        }\n        .NotAllowed:hover {\n          opacity: 0.7;\n        }\n      }\n      .ButtonContainer{\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        gap: 3.75rem;\n        margin-top: 1.25rem;\n        button{\n          height: 2rem;\n          width: 8.75rem;\n          border: none;\n          border-radius: 0.5rem;\n          color: #FFFFFF;\n          font-size: 0.875rem;\n          background: var(--AccentColor);\n          font-weight: 500;\n          cursor: pointer;\n        }\n        button:disabled{\n          opacity: 0.2;\n          scale: 1;\n          cursor: not-allowed;\n        }\n        .Skip{\n          background: var(--Background);\n          color: var(--AccentColor);\n          transition: all 0.3s ease;\n        }\n        .Skip:hover{\n          background: var(--Stroke);\n          color: var(--TextColor);\n          transition: all 0.3s ease;\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
